import {
  Sparkles,
  ShieldCheck,
  Droplets,
  Layers,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/data/site";

const ICONS = { Sparkles, ShieldCheck, Droplets, Layers };

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-20 md:py-40 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-16 reveal">
          <div className="md:col-span-5">
            <p className="eyebrow">01 — Capabilities</p>
            <h2 className="font-display text-white font-light text-4xl md:text-6xl tracking-tighter mt-4 leading-[1.05]">
              Services that{" "}
              <span className="gold-text italic font-medium">obsess</span> over
              the millimetre.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-white/60 text-base md:text-lg leading-relaxed">
              Every package is tailored to the vehicle in front of us. We move
              between the polisher, the steam wand and the coating bench with
              one objective — return your motor better than the day it left the
              factory.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:auto-rows-[260px] gap-5">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.iconKey] || Sparkles;
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`group relative overflow-hidden border border-white/8 bg-[#0E0E0E] ${s.span} reveal`}
                style={{ transitionDelay: `${idx * 80}ms` }}
              >
                <div className="absolute inset-0">
                  <img
                    src={s.image}
                    alt={s.name}
                    className="w-full h-full object-cover opacity-50 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/30" />
                </div>
                <div className="relative h-full min-h-[300px] p-7 flex flex-col justify-between">
                  <div className="flex items-start justify-between">
                    <div className="w-11 h-11 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">
                      <Icon className="w-5 h-5" />
                    </div>
                    <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-[#D4AF37] group-hover:rotate-12 transition-all duration-500" />
                  </div>
                  <div>
                    <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/80 mb-3">
                      0{idx + 1}
                    </p>
                    <h3 className="font-display text-white text-2xl md:text-3xl font-light leading-tight tracking-tight">
                      {s.name}
                    </h3>
                    <p className="text-white/60 text-sm mt-3 leading-relaxed max-w-md">
                      {s.blurb}
                    </p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-12 flex items-center gap-4 reveal">
          <div className="flex-1 gold-line" />
          <p className="text-xs uppercase tracking-[0.35em] text-white/40">
            Bespoke packages on request
          </p>
          <div className="flex-1 gold-line" />
        </div>
      </div>
    </section>
  );
}
